import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import React, { useContext, useState } from 'react';
import { IItemComboGroup } from 'types';
import DataController from 'components/DataController/DataController';
import Info from './components/Info/Info';
import { ComboGroupContext, IComboGroupContext } from '../../../../../comboGroupState/comboGroupContext';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IItemComboGroup;
	index: number;
}

const Item: React.FC<IItem> = ({ data, index }) => {
	const { setIDForDeletion, IDSelectedDish } = useContext<IComboGroupContext>(ComboGroupContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);

	const containerClasses = classNames(style.container, { [style.openInfo]: isOpenInfo });
	const comboGroupRowClasses = classNames(style.comboGroup, style.row, style.list);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const customerRowClasses = classNames(style.customer, style.row, style.list);
	const positionRowClasses = classNames(style.position, style.row, style.list);
	const actionRowClasses = classNames(style.action, style.row);

	const restaurants = data.restaurants.map((el) => ({
		...el,
		id: el.restaurantId,
	}));

	const position = data.dishes.find((dish) => dish.id === IDSelectedDish)?.positionNumber;

	const handleClickInfo = () => {
		setIsOpenInfo(!isOpenInfo);
	};

	const handleSetIdForDeletion = () => {
		setIDForDeletion(data.id);
	};

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<Text className={comboGroupRowClasses} translationKey={data.name} withTooltip={true} data-test="name" />
				<div className={restaurantRowClasses}>
					<RestaurantsList restaurants={restaurants} />
				</div>
				<Text
					className={customerRowClasses}
					translationKey={data.customer.name}
					withTooltip={true}
					data-test="customerName"
				/>
				<Text
					className={positionRowClasses}
					translationKey={position ? String(position) : '-'}
					withTooltip={true}
					data-test="position"
				/>
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={handleClickInfo}
						onClickDelete={handleSetIdForDeletion}
						URLWithIDToEdit={`/menu/combo-group/edit?comboGroupID=${data.id}`}
						size="smallBtn"
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} />
		</div>
	);
};

export default Item;
